import { makeStyles } from '@material-ui/core/styles';
import { THEME } from 'GlobalStyles';
import { container } from 'UI/constants/dimensions';
import { flexAlignCenterJustifyCenter } from 'UI/utils/styles';

export const cardStyles = {
  root: {
    boxShadow: container.boxShadow,
    position: 'relative',
    zIndex: 0,
    borderRadius: 12
  }
};

const fontFamily = THEME.typography.fontFamilyHeader;

const sharedHeaderStyles = {
  root: {
    padding: THEME.spacing(2),
    backgroundColor: THEME.palette.grey[50]
  }
};

const sharedSubHeaderStyles = {
  color: THEME.palette.status.inactive
};

export const headerStyles = {
  regular: {
    root: {
      backgroundColor: THEME.palette.grey[50]
    },
    title: {
      fontWeight: THEME.typography.headerWeights.bold,
      fontSize: 20,
      fontFamily
    }
  },
  hero: {
    subheader: {
      paddingTop: THEME.spacing(0.5),
      ...sharedSubHeaderStyles
    },
    ...sharedHeaderStyles
  },
  section: {
    subheader: {
      ...sharedSubHeaderStyles
    },
    ...sharedHeaderStyles
  }
};

export const useHeaderStyles = ({ variant }) => makeStyles(() => headerStyles[variant]);

export const useActionStyles = makeStyles({
  actionAndExpandContainer: {
    alignItems: 'center'
  }
});

const contentStyles = {
  tight: {
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  regular: {
    padding: THEME.spacing(2)
  },
  relaxed: {
    padding: THEME.spacing(3)
  }
};

export const useContentStyles = makeStyles({
  root: ({ variant }) => ({ ...contentStyles[variant] })
});

export const useFooterStyles = makeStyles(theme => ({
  buttonContainer: {
    margin: theme.spacing(2, 0, 0),
    ...flexAlignCenterJustifyCenter
  }
}));
